import React from "react";
import { useParams, Link } from "react-router-dom";
import { useForm, useFieldArray } from "react-hook-form";
import useSWR from "swr";
import fetcher, { METHODS } from "./services/fetcher";
import Input from "./components/Input";
import Message from "./components/Message";
import Header from "./components/Header";
import Footer from "./components/Footer";

export default function Availability() {
  const { uuid } = useParams();

  const { register, handleSubmit, control, errors, reset } = useForm();

  const { fields, remove } = useFieldArray({
    control,
    name: "missed_check_ins",
  });

  const [serverResponse, setServerResponse] = React.useState();
  const [recentData, setRecentData] = React.useState({});
  const [recentHotelInfo, setRecentHotelInfo] = React.useState({});
  const [
    hotelInfoServerResponse,
    setHotelInfoServerResponse,
  ] = React.useState();

  const { data = {} } = useSWR(
    `${process.env.REACT_APP_HE_API_HOST}/hotel_partners/${uuid}/hotel_partner_availabilities`,
    fetcher,
    {
      errorRetryCount: 1,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const { data: hotelInfo = {} } = useSWR(
    `${process.env.REACT_APP_HE_API_HOST}/hotel_partners/${uuid}`,
    fetcher,
    {
      errorRetryCount: 1,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  // if (error) throw new Error(error);

  React.useEffect(() => {
    if (Object.keys(data).length) {
      setRecentData(data);

      if (data.missed_check_ins && data.missed_check_ins.length) {
        reset({ missed_check_ins: data.missed_check_ins });
      }
    }
  }, [data, reset]);

  React.useEffect(() => {
    if (Object.keys(hotelInfo).length) {
      setRecentHotelInfo(hotelInfo);
    }
  }, [hotelInfo]);

  const updateHotelInfo = (data) => {
    console.log(`data: `, data);
    console.log(`recentHotelInfo: `, recentHotelInfo);
    if (
      data &&
      recentHotelInfo &&
      data.booking_link === recentHotelInfo.booking_link
    )
      return;
    try {
      fetcher(
        `${process.env.REACT_APP_HE_API_HOST}/hotel_partners/${uuid}`,
        METHODS.PUT,
        { ...recentHotelInfo, ...data }
      ).then((d) => {
        setRecentHotelInfo(d);
        setHotelInfoServerResponse({
          type: "Success",
          message: "Updated!",
        });
      });
      // .catch((error) => {
      //   setHotelInfoServerResponse({ type: "Error", message: error.message });
      // });
    } catch (error) {
      setHotelInfoServerResponse({ type: "Error", message: error.message });
    }
  };

  const onSubmit = (data) => {
    try {
      fetcher(
        `${process.env.REACT_APP_HE_API_HOST}/hotel_partners/${uuid}/hotel_partner_availabilities`,
        METHODS.POST,
        data
      ).then((d) => {
        setRecentData(d);
        setServerResponse({
          type: "Success",
          message: "Form successfully submitted",
        });
      });
    } catch (error) {
      setServerResponse({ type: "Error", message: error.message });
    }
  };

  return (
    <div className="flex flex-col container mx-auto items-center mt-4">
      <Header
        {...recentHotelInfo}
        updated_at={recentData.updated_at}
        update={updateHotelInfo}
        serverResponse={hotelInfoServerResponse}
        serverResponseReset={() => setHotelInfoServerResponse()}
      />
      <div
        className="bg-red-100 border-t border-b border-red-500 text-red-700 px-4 py-1 w-full max-w-2xl lg:max-w-3xl mb-3"
        role="alert">
        <div className="flex items-center">
          <div className="py-1 mr-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-alert-circle">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
          </div>
          <div>
            <p className="font-semibold text-sm">
              If guest has not checked in within 48 hours of check in date,
              please cancel reservation.
            </p>
          </div>
        </div>
      </div>
      <form
        className="w-full max-w-2xl lg:max-w-3xl shadow p-4 bg-white relative"
        onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-wrap md:-mx-3 mb-4">
          <div className="w-full md:w-1/2 px-3 mb-4 md:mb-0">
            <Input
              label="# of available one bed rooms"
              name="one_bed_rooms"
              type="number"
              placeholder={0}
              value={recentData.one_bed_rooms}
              ref={register({ required: true })}
              errors={errors}
            />
          </div>
          <div className="w-full md:w-1/2 px-3 mb-4 md:mb-0">
            <Input
              label="# of available 2 bed rooms"
              name="two_bed_rooms"
              type="number"
              placeholder={0}
              value={recentData.two_bed_rooms}
              ref={register({ required: true })}
              errors={errors}
            />
          </div>
        </div>
        <div className="flex flex-wrap md:-mx-3 mb-4">
          <div className="w-full md:w-1/2 px-3 mb-4 md:mb-0">
            <Input
              label="# of available rooms per floor"
              name="rooms_by_floor"
              type="number"
              placeholder={0}
              value={recentData.rooms_by_floor}
              ref={register({ required: true })}
              errors={errors}
            />
          </div>
          <div className="w-full md:w-1/2 px-3">
            <Input
              label="# of available ADA rooms"
              name="accessible_rooms"
              type="number"
              placeholder={0}
              value={recentData.accessible_rooms}
              ref={register({ required: true })}
              errors={errors}
            />
          </div>
        </div>
        <hr className="mb-8" />
        <div className="flex flex-wrap md:-mx-3 mb-4">
          <div className="w-full md:w-1/2 px-3 mb-4 md:mb-0">
            <Input
              label="# of available rooms with kitchenettes"
              name="rooms_with_kitchen"
              type="number"
              placeholder={0}
              value={recentData.rooms_with_kitchen}
              ref={register({ required: true })}
              errors={errors}
            />
          </div>
          <div className="w-full md:w-1/2 px-3">
            <Input
              label="# of available rooms with microwaves"
              name="rooms_with_microwave"
              type="number"
              placeholder={0}
              value={recentData.rooms_with_microwave}
              ref={register({ required: true })}
              errors={errors}
            />
          </div>
        </div>
        <div className="flex flex-wrap md:-mx-3 mb-4">
          <div className="w-full md:w-1/2 px-3 mb-4 md:mb-0">
            <Input
              label="# of available rooms with refrigerators"
              name="rooms_with_fridge"
              type="number"
              placeholder={0}
              value={recentData.rooms_with_fridge}
              ref={register({ required: true })}
              errors={errors}
            />
          </div>
          <div className="w-full md:w-1/2 px-3">
            <Input
              label="# of total rooms"
              name="total_rooms"
              type="number"
              placeholder={0}
              value={recentData.total_rooms}
              ref={register({ required: true })}
              errors={errors}
            />
          </div>
        </div>
        <hr className="mb-8" />
        <div className="flex flex-wrap md:-mx-3 mb-4">
          <div className="w-full md:w-1/2 px-3 mb-4 md:mb-0">
            <Input
              label="# of available cribs"
              name="cribs"
              type="number"
              placeholder={0}
              value={recentData.cribs}
              ref={register({ required: true })}
              errors={errors}
            />
          </div>
          <div className="w-full md:w-1/2 px-3">
            <Input
              label="# of available rollaways"
              name="rollaways"
              type="number"
              placeholder={0}
              value={recentData.rollaways}
              ref={register({ required: true })}
              errors={errors}
            />
          </div>
        </div>
        <hr className="mb-4" />
        <div className="flex flex-wrap md:-mx-3 mb-4">
          <div className="flex w-full px-3 mb-4 md:mb-0 items-center text-gray-700 justify-center">
            <Link
              to={(location) => `${location.pathname}/contracts`}
              className="inline-flex items-center bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-1 px-2 border border-blue-500 hover:border-transparent rounded">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="fill-current mr-2">
                <line x1="8" y1="6" x2="21" y2="6"></line>
                <line x1="8" y1="12" x2="21" y2="12"></line>
                <line x1="8" y1="18" x2="21" y2="18"></line>
                <line x1="3" y1="6" x2="3.01" y2="6"></line>
                <line x1="3" y1="12" x2="3.01" y2="12"></line>
                <line x1="3" y1="18" x2="3.01" y2="18"></line>
              </svg>
              <span>View and Update Rooming List</span>
            </Link>
            {/* <button
              type="button"
              className="inline-flex items-center bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-1 pl-1 pr-2 border border-blue-500 hover:border-transparent rounded"
              onClick={() => append({ name: "missed_check_ins" })}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="fill-current">
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
              <span className="text-xs">Add</span>
            </button> */}
          </div>
        </div>
        {fields.map((field, i) => (
          <React.Fragment key={field.id}>
            {/* desktop view */}
            <div className="hidden flex-wrap md:flex md:-mx-3 mb-4 items-center">
              <div className="w-full md:w-1/2 px-3 mb-4 md:mb-0">
                <Input
                  label="Confirmation #"
                  name={`missed_check_ins[${i}].reservation_number`}
                  type="text"
                  placeholder="12345"
                  value={field.reservation_number}
                  ref={register({ required: true })}
                  errors={errors}
                />
              </div>
              <div className="w-full md:w-1/2 px-3">
                <Input
                  label="Guest name"
                  remove={true}
                  onRemove={() => remove(i)}
                  name={`missed_check_ins[${i}].guest_name`}
                  type="text"
                  placeholder="John Smith"
                  value={field.guest_name}
                  ref={register({ required: true })}
                  errors={errors}
                />
              </div>
            </div>
            {/* mobile view */}
            <div className="flex flex-wrap md:-mx-3 mb-4 items-center md:hidden">
              <div className="w-full md:w-1/2 px-3 mb-4 md:mb-0">
                <Input
                  label="Confirmation #"
                  remove={true}
                  onRemove={() => remove(i)}
                  name={`missed_check_ins[${i}].reservation_number`}
                  type="text"
                  placeholder="12345"
                  ref={register({ required: true })}
                  errors={errors}
                />
              </div>
              <div className="w-full md:w-1/2 px-3">
                <Input
                  label="Guest name"
                  name={`missed_check_ins[${i}].guest_name`}
                  type="text"
                  placeholder="John Smith"
                  ref={register({ required: true })}
                  errors={errors}
                />
              </div>
            </div>
          </React.Fragment>
        ))}
        <hr className="mb-8" />
        <div className="flex flex-wrap md:-mx-3 mb-4 items-center">
          <div className="w-full md:w-1/2 px-3 mb-4 md:mb-0">
            <Input
              label="Updated By"
              name="updated_by"
              type="text"
              placeholder="Jane Doe"
              value={recentData.updated_by}
              ref={register({ required: true })}
              errors={errors}
            />
          </div>
          <div className="flex justify-end w-full md:w-1/2 px-3">
            <button
              className="shadow bg-blue-500 hover:bg-blue-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded mt-2"
              style={{ height: 46 }}
              type="submit">
              Submit
            </button>
          </div>
        </div>
        {serverResponse && (
          <Message
            type={serverResponse.type}
            message={serverResponse.message}
            reset={() => setServerResponse()}
          />
        )}
      </form>
      <Footer />
    </div>
  );
}
